/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EmailNotifyConfiguration {
    getFixupPrototypeFunction() { return EmailNotifyConfiguration.fixupPrototype; }

    static newInstance(model: Partial<EmailNotifyConfiguration>): EmailNotifyConfiguration {
        let obj = Object.assign(new EmailNotifyConfiguration(), model);
        EmailNotifyConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EmailNotifyConfiguration>): EmailNotifyConfiguration {
        if (!model) return null;
        return EmailNotifyConfiguration.newInstance(<EmailNotifyConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EmailNotifyConfiguration) {
        if (!obj) return;

        models.EmailNotifyConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EmailNotifyConfiguration): boolean {
        Object.setPrototypeOf(obj, EmailNotifyConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloudops_automation_jobs) {
            models.CloudOpsAutomationJobs.fixupPrototype(this.cloudops_automation_jobs);
        }
        if (this.cloud_account_configuration) {
            models.CloudAccountConfiguration.fixupPrototype(this.cloud_account_configuration);
        }
        if (this.email_report_configuration) {
            models.EmailReportConfiguration.fixupPrototype(this.email_report_configuration);
        }
    }

    /**
     * CloudOps automation job notification settings
     */
    cloudops_automation_jobs: models.CloudOpsAutomationJobs;

    /**
     * Cloud account notification settings
     */
    cloud_account_configuration: models.CloudAccountConfiguration;

    /**
     * Email report configuration settings
     */
    email_report_configuration: models.EmailReportConfiguration;

}
